import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/signup')({
  beforeLoad: () => {
    throw redirect({ to: '/project' });
  },
});
